module.exports = __webpack_public_path__ + "static/media/backBlack.a1339c0f.svg";